import {
	createFetchStore,
	createFetcher,
	createFetchHook,
} from '@atlassian/jira-insights-fetch/src/controllers/use-fetch/utils/sweet-state.tsx';
import { fetchArisSprintCommitmentResponseSuccess } from '@atlassian/jira-insights-sprint-commitment/src/services/aris-sprint-history/index.tsx';

type SprintCommitmentParams = {
	cloudId: string;
	rapidViewId: number;
	shouldUseJQLData: boolean;
};

const PACKAGE_NAME = 'jiraSprintCommitmentIndicator';
export const SPRINT_COMMITMENT_ANALYTICS_ID = 'getSprintCommitment';

const Store = createFetchStore({ name: 'sprint-commitment-store' });

export const sprintCommitmentFetcher = createFetcher({
	getKey: ({ cloudId, rapidViewId }) => `sprint-commitment-${cloudId}-${rapidViewId}`,
	getData: (fetchOptions, { cloudId, rapidViewId, shouldUseJQLData }: SprintCommitmentParams) => {
		return fetchArisSprintCommitmentResponseSuccess(
			{
				cloudId,
				rapidViewId,
				shouldUseJQLData,
			},
			fetchOptions,
		);
	},
	getProps: () => ({
		analyticsTracking: {
			actionSubject: `useFetch.${SPRINT_COMMITMENT_ANALYTICS_ID}`,
			packageName: PACKAGE_NAME,
			action: 'dataFetch',
		},
		loggingKey: `${PACKAGE_NAME}.${SPRINT_COMMITMENT_ANALYTICS_ID}`,
		isAutoFetchable: false,
	}),
});

export const useSprintCommitmentFetcher = createFetchHook(sprintCommitmentFetcher, Store);
